// features/ups/modals/ConfirmDeleteModal.js
// Safety dialog for deleting an agency; requires typing the agency name and fires onConfirm only when matched.
import React, { useState } from 'react';
import { X } from 'lucide-react';

export default function ConfirmDeleteModal({ isOpen, onClose, agency, onConfirm }) {
  const [typed, setTyped] = useState('');
  const canDelete = typed.trim() === (agency?.name ?? '');

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-xl w-full max-w-lg shadow-lg" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold text-red-700">Delete agency</h3>
          <button onClick={onClose} className="p-1 rounded hover:bg-gray-100"><X size={18} /></button>
        </div>
        <div className="p-4 space-y-4">
          <p>
            This will permanently delete <span className="font-semibold">{agency?.name}</span>.
            Type the agency name to confirm.
          </p>
          <input className="w-full border rounded px-3 py-2" value={typed} onChange={e => setTyped(e.target.value)} />
        </div>
        <div className="p-4 border-t flex items-center justify-end">
          <button onClick={onClose} className="px-3 py-2 rounded bg-gray-100 hover:bg-gray-200 mr-2">Cancel</button>
          <button disabled={!canDelete} onClick={onConfirm} className="px-3 py-2 rounded bg-red-600 text-white disabled:opacity-60">
            Delete agency
          </button>
        </div>
      </div>
    </div>
  );
}
